import { render, staticRenderFns } from "./koUserProtocol.vue?vue&type=template&id=7dc35c44&scoped=true&"
import script from "./koUserProtocol.vue?vue&type=script&lang=js&"
export * from "./koUserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./koUserProtocol.vue?vue&type=style&index=0&id=7dc35c44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc35c44",
  null
  
)

export default component.exports